export function hudSelector(state) {
  return state.hud;
}
